import React from 'react'
import RevealOnScroll from '../atoms/RevealOnScroll'
import styles from './ProcessSection.module.css'

import s2Grid1 from '../../assets/images/s2-grid1.jpg'
import s2Grid2 from '../../assets/images/s2-grid2.jpg'
import s2Grid3 from '../../assets/images/s2-grid3.jpg'
import s2Hero from '../../assets/images/s2-hero.jpg'

const steps = [
    {
        title: 'Fill out the form',
        text: 'Our fast, safe and secure online form can be completed in just 2 quick minutes.',
        image: s2Grid1
    },
    {
        title: 'All credit types considered',
        text: 'You can fill out our online form with any level of credit rating, from no rating to excellent!',
        image: s2Grid2
    },
    {
        title: 'Get your cash',
        text: 'Our lenders will directly deposit funds to your account as fast as the next business day.',
        image: s2Grid3
    }
]

export const ProcessSection = () => {
    return (
        <section className={styles.processSection}>
            <div className={styles.contentContainer}>
                {/* Left Column (Text) */}
                <RevealOnScroll className={styles.leftColumn} animation="fade-in" threshold={0.2}>
                    <h2 className={styles.sectionHeading}>
                        Getting the right loan has<br />never been easier.
                    </h2>

                    <div className={styles.heroImageWrapper}>
                        <img src={s2Hero} alt="Loan Process" className={styles.heroImage} />
                    </div>

                    <p className={styles.sectionDescription}>
                        Trustedonlineloans makes borrowing quick and easy, no matter your credit score. We connect you with trusted lenders for competitive rates, flexible terms, and fast approval-all from the comfort of home!
                    </p>
                </RevealOnScroll>

                {/* Right Column (Steps) */}
                <div className={styles.rightColumn}>
                    <div className={styles.stepsGrid}>
                        {steps.map((step, index) => (
                            <RevealOnScroll
                                key={index}
                                className={styles.processStep}
                                animation="reveal-up"
                                threshold={0.2}
                                delay={index * 150}
                            >
                                <div className={styles.stepImageWrapper}>
                                    <img src={step.image} alt={step.title} className={styles.stepImage} />
                                </div>
                                <div className={styles.stepContent}>
                                    <h3 className={styles.stepTitle}>{step.title}</h3>
                                    <p className={styles.stepText}>{step.text}</p>
                                </div>
                            </RevealOnScroll>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ProcessSection
